import * as actions from "./audit-logs.action";

const auditLogsReducer = (state = {}, action) => {
  switch (action.type) {
    case actions.AUDIT_LOGS_LOADING:
      return {
        ...state,
        [actions.AUDIT_LOGS_LOADING]: action.payload
      };
    case actions.GET_AUDIT_LOGS:
      return {
        ...state,
        [actions.GET_AUDIT_LOGS]: action.payload
      };
    case actions.AUDIT_LOGS_ERRORS:
      return {
        ...state,
        [actions.AUDIT_LOGS_ERRORS]: action.payload
      };
    case actions.EXPORT_AUDIT_LOGS_LOADING:
      return {
        ...state,
        [actions.EXPORT_AUDIT_LOGS_LOADING]: action.payload
      };
    case actions.EXPORT_AUDIT_LOGS:
      return {
        ...state,
        [actions.EXPORT_AUDIT_LOGS]: action.payload
      };
    case actions.EXPORT_AUDIT_LOGS_ERRORS:
      return {
        ...state,
        [actions.EXPORT_AUDIT_LOGS_ERRORS]: action.payload
      };
    default:
      return state;
  }
};

export default auditLogsReducer;
